import React from 'react';
import {
  IconListType,
  IconListItemType,
} from '@tcs/create-account/utils/prismic/types';
import IconLink from './IconLink';
import { useStyles } from './style';

interface IconLinksProps {
  data: IconListType;
  items: IconListItemType[];
}

const IconLinks: React.FC<IconLinksProps> = ({ data, items }) => {
  const classes = useStyles();
  const { title } = data;

  const list = items.map((item) => <IconLink data={item} key={item.name} />);

  return (
    <section className={classes.wrapper}>
      {title && <h2 className={classes.title}>{title}</h2>}
      <div className={classes.list}>{list}</div>
    </section>
  );
};

export default IconLinks;
